<template>
    <div class="columns">
        <section class="section column is-2 menu-background">
            <Menu />
        </section>
        <section class="column is-10">

            <div class="navbar-custom-pc">
                <NavBar />
            </div>
            <div>
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <span class="is-size-3 has-text-weight-bold">New Product</span>

                        </div>
                    </div>
                </div>
                <form @submit.prevent="addProduct">
                    <section>
                        <b-field label="Product Image">
                            <b-field class="file is-primary" :class="{'has-name': !!image_file}">
                                <b-upload v-model="image_file" class="file-label" rounded>
                                    <span class="file-cta">
                                        <b-icon class="file-icon" icon="upload"></b-icon>
                                        <span class="file-label">Upload image</span>
                                    </span>
                                    <span class="file-name" v-if="image_file">
                                        {{ image_file.name }}
                                    </span>
                                </b-upload>
                            </b-field>
                        </b-field>
                        <b-field label="Product Name">
                            <b-input v-model="product_name" required placeholder="Basin" icon-pack="fas"
                                icon="fas fa-boxes"></b-input>
                        </b-field>

                        <b-field label="Select Product Family">
                            <b-select placeholder="Select product family" required v-model="product_family">
                                <option v-for="option in allFamily" :value="option.family_id" :key="option.family_id">
                                    {{ option.family_name }}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field label="Rack Number">
                            <b-input v-model="rack" required placeholder="A1" icon-pack="fas"
                                icon="fas fa-grip-horizontal"></b-input>
                        </b-field>
                        <b-field label="Purchase Price">
                            <b-input  min ="1" v-model="retail_price_gamma" required placeholder="123.45" icon-pack="fas"
                                icon="fas fa-dollar-sign"></b-input>
                        </b-field>
                        <b-field label="Wholesale Price">
                            <b-input  min ="1" v-model="wholesale_price" required placeholder="123.45" icon-pack="fas"
                                icon="fas fa-hand-holding-usd"></b-input>
                        </b-field>
                        <b-field label="Retail Price (Type 1)">
                            <b-input  min ="1" v-model="retail_price_alpha" required placeholder="123.45" icon-pack="fas"
                                icon="fas fa-money-check-alt"></b-input>
                        </b-field>
                        <b-field label="Retail Price (Type 2)">
                            <b-input  min ="1" v-model="retail_price_beta" placeholder="123.45" icon-pack="fas"
                                icon="fas fa-money-check-alt"></b-input>
                        </b-field>

                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="button" @click="goBack()" icon-pack="fas" icon-right="fas fa-times"
                        type="is-danger">
                        Cancel</b-button>
                    <b-button class="button is-success" icon-pack="fas" native-type="submit" :loading="isLoading"
                        icon-right="fas fa-plus">Create</b-button>
                    </footer>
                    
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Menu from '@/components/Menu.vue'
export default {
    name: "AddNewProduct",
    components: {
        NavBar,
        Menu
    },
    data() {
        return {
            image_file: null,
            product_name: null,
            allFamily: [],
            product_family: null,
            isLoading: false,
            rack: null,
            retail_price_gamma: null,
            wholesale_price: null,
            retail_price_alpha: null,
            retail_price_beta: null
        }
    },
    mounted() {
        this.$store.dispatch('getAllProductFamily')
            .then((response) => {
                if (response.error == 0) {
                    this.allFamily = []
                    this.allFamily.push(...response.result.family_data)
                } else {
                    this.ToastError("Problem loading family")
                }
            })
            .catch(() => {
                this.ToastError("Problem loading family")
            })


    },
    methods: {
        addProduct() {
            if (this.product_name && this.product_family && this.rack && this.retail_price_gamma && this.wholesale_price && this.retail_price_alpha) {
                this.isLoading = true
                const actual_retail_price_beta = this.retail_price_beta ? this.retail_price_beta : 0
                this.$store.dispatch('addProduct', {
                        product_image: this.image_file,
                        product_name: this.product_name,
                        product_family: this.product_family,
                        rack: this.rack,
                        retail_price_gamma: this.retail_price_gamma,
                        wholesale_price: this.wholesale_price,
                        retail_price_alpha: this.retail_price_alpha,
                        retail_price_beta: actual_retail_price_beta
                    })
                    .then((response) => {
                        if (response.error == 0) {

                            // this.$store.dispatch('GetAllActiveProjects')
                            //     .then((response) => {})

                            this.ToastSuccess("New product Created")
                            this.image_file = null
                            this.product_name = null

                            this.product_family = null

                            this.rack = null,
                                this.retail_price_gamma = null,
                                this.wholesale_price = null,
                                this.retail_price_alpha = null,
                                this.retail_price_beta = null
                        } else {
                            this.ToastError("Product creation failed")
                        }
                    })
                    .catch(() => {
                        this.ToastError("Product creation failed")
                    })
                    .finally(() => {
                        this.isLoading = false
                    })

            } else {
                this.ToastError("Please fill required fields")
            }
        },
         goBack(){
            this.$router.go(-1)
        }
    }
}
</script>

<style>
/* .menu-background{
    background-color: #26547C;
} */
</style>